import { sepolia, bsc } from 'wagmi/chains';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import config from './config';
import { Chain, http } from 'viem';

const envChains = {
  development: sepolia,
  production: bsc,
};

export const getEnvChain = () => {
  const env = config.get('env');
  return envChains[env as keyof typeof envChains];
};

const getAlchemyRpcUrl = (chain: Chain) => {
  const networkName = (() => {
    switch (chain.id) {
      case sepolia.id:
        return 'eth-sepolia';
      case bsc.id:
        return 'bnb-mainnet';
      default:
        return `${chain.name.toLowerCase()}-mainnet`;
    }
  })();

  return `https://${networkName}.g.alchemy.com/v2/${config.get('alchemy.apiKey')}`;
};

export const wagmiConfig = getDefaultConfig({
  appName: 'Token Racer',
  projectId: config.get('walletConnect.projectId'),
  chains: [getEnvChain()],
  transports: {
    [getEnvChain().id]: http(getAlchemyRpcUrl(getEnvChain())),
  },
});

const envAddresses = {
  development: {
    tokenRacer: '0xcE0D4a004a8882013AC7DA12a51652C6B79FBD2D' as `0x${string}`,
    tokenRacerOracle: '0x7Ed926f2A48D63204286A525171F749bA5C17be4' as `0x${string}`,
    usdc: {
      address: '0x45415787f4C5612d60aD1ac982Ff1010f9c88Aa6' as `0x${string}`,
      decimals: 18,
    },
  },
  production: {
    tokenRacer: '0xE24d69eAe15bab28Ab41B68b96f0A836fD2C715e' as `0x${string}`,
    tokenRacerOracle: '0x963DF0cC4BCa4D758231d084BDF8dF039839d1fC' as `0x${string}`,
    usdc: {
      address: '0x55d398326f99059ff775485246999027b3197955' as `0x${string}`,
      decimals: 18,
    },
  },
};

export const getEnvAddresses = () => {
  const env = config.get('env');
  return envAddresses[env as keyof typeof envAddresses];
};
